export default {
      id: "oc-res-billrate-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-billrate",
      toString: function () {
        return this.url;
      }
    }